import styled from "styled-components";

export const BackStyled = styled.div`
  .back_btn {
    width: 42px;
    height: 42px;
    background-color: #f5f5f5;
    border-radius: 8px;
    .icon {
      color: #0f6fdf;
      font-size: 28px;
    }
  }
`;
